import { useQuery } from '@tanstack/react-query';
import API from '../../api/api';

const fetchDropboxFolder = async (url) => {
  try {
  

    const response = await API.post('/dropbox/folder/list',JSON.stringify({url:url}));

    // Axios response.data contains the response body
    return response.data?.data?.files || [];
  } catch (error) {
    // Handle Axios-specific errors
    throw new Error(
      error.response?.data?.message || 
      `HTTP ${error.response?.status || 'Unknown'}: Failed to fetch folder contents`
    );
  }
};

export const useDropboxFolder = (url) => {
  return useQuery({
    queryKey: ['dropboxFolder', url],
    queryFn: () => fetchDropboxFolder(url),
    enabled: !!url, // Only fetch if url is provided
    retry: 1, // Retry once on failure
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    throwOnError: false, // Let components handle errors
    select: (data) => data, // Optional: transform data if needed
  });
};